<template>
  <div class="element-logo" :class="{'reverse': reverse}">
    <template v-if="reverse">
      <template v-if="$slots.reverse">
        <slot name="reverse"></slot>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'ElementLogo',
  props: {
    reverse: Boolean
  }
}
</script>

<style lang="scss">
  .element-logo {
    height: 100%;
  }
</style>
